module.exports = __webpack_public_path__ + "static/media/univar.9dae57f1.png";